const MONTH_IN_MS = 1000 * 60 * 60 * 24 * 30;

const getSasTokenExpiryTimestamp = (sasToken) => {
    const params = new URLSearchParams(sasToken);

    // Get the 'se' (signed expiry) parameter
    const expiry = params.get('se');
    if (!expiry) {
        return 0;
    }

    return new Date(expiry).getTime();
};

exports.getSasTokenExpiryDateString = (sasToken) => {
    const expiryTimestamp = getSasTokenExpiryTimestamp(sasToken);
    const expiryDate = new Date(expiryTimestamp);
    const formatted = expiryDate.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });
    return formatted;
};

exports.isSasTokenExpired = (sasToken) => {
    const sasTokenExpiry = getSasTokenExpiryTimestamp(sasToken);
    const timeDiff = sasTokenExpiry - Date.now();
    return timeDiff < 0;
};

exports.isSasTokenAboutToExpire = (sasToken) => {
    const sasTokenExpiry = getSasTokenExpiryTimestamp(sasToken);
    const timeDiff = sasTokenExpiry - Date.now();
    return !exports.isSasTokenExpired(sasToken) && timeDiff < MONTH_IN_MS;
};
